module.exports = __webpack_public_path__ + "static/media/cabin_woman.14d30fa2.jpeg";